import apiClient from "./client";

export function createUser(payload) {
  // payload = { username, password, groups: ["User"] }
  return apiClient.post("api/users/", payload);
}

export async function fetchUsers() {
  const users = [];
  let page = 1;

  while (true) {
    const { data } = await apiClient.get("api/users/", {
      params: { page, ordering: "-date_joined" },
    });

    if (Array.isArray(data)) return data;

    users.push(...(data.results ?? []));
    if (!data.next) break;
    page += 1;
  }

  return users;
}

export const deleteUser = async (id) => {
  await apiClient.delete(`api/users/${id}/`);
  return id;
};

// PATCH /api/users/:id/
// Accepts partial updates: { id, username?, password?, groups? }
export const updateUser = async ({ id, username, password, groups }) => {
  const payload = {};
  if (username !== undefined) payload.username = username;
  if (password !== undefined) payload.password = password;
  if (groups !== undefined) payload.groups = groups;
  const { data } = await apiClient.patch(`api/users/${id}/`, payload);
  return data;
};
